import ErrorAlert from '../../common/ErrorAlert';
import { Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

const ChangeBucketError = () => {
  const { t } = useTranslations(translations);

  return (
    <ErrorAlert>
      <Text>
        {t('There was an error completing that action, please try again')}
      </Text>
    </ErrorAlert>
  );
};

export default ChangeBucketError;
